import { isEmailBuilderTextEditableTarget } from "./emailBuilderHistoryHotkeys";

export type TEmailBuilderRowGroupHotkeyAction = "group" | "ungroup";

export interface IEmailBuilderRowGroupHotkeyEvent {
  key: string;
  ctrlKey: boolean;
  metaKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
  target: EventTarget | null;
}

export function resolveEmailBuilderRowGroupHotkey(
  event: IEmailBuilderRowGroupHotkeyEvent,
): TEmailBuilderRowGroupHotkeyAction | null {
  if (isEmailBuilderTextEditableTarget(event.target)) {
    return null;
  }

  if (event.altKey) {
    return null;
  }

  const modifierPressed = event.metaKey || event.ctrlKey;
  if (!modifierPressed) {
    return null;
  }

  if (event.key.toLowerCase() !== "g") {
    return null;
  }

  return event.shiftKey ? "ungroup" : "group";
}

export function emailBuilderRowGroupHotkeyShortcutLabels(isMac: boolean): {
  group: string;
  ungroup: string;
} {
  if (isMac) {
    return {
      group: "⌘G",
      ungroup: "⌘⇧G",
    };
  }

  return {
    group: "Ctrl+G",
    ungroup: "Ctrl+Shift+G",
  };
}

export function emailBuilderRowGroupRailActionTooltip(
  action: TEmailBuilderRowGroupHotkeyAction,
  label: string,
  isMac: boolean,
): string {
  const labels = emailBuilderRowGroupHotkeyShortcutLabels(isMac);
  return `${label} (${labels[action]})`;
}
